import * as Yup from 'yup'

const validUrlRegex = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm

export const AnnouncementSchema = Yup.object().shape({
  title: Yup.string().required('This field is required.'),
  endDate: Yup.date().typeError('Please specify a valid end date.').required('This field is required.'),
  description: Yup.string().max(1500, 'Only 1500 characters allowed in description of announcements.').required('This field is required.'),
  link: Yup.string().matches(validUrlRegex, 'Link is not valid.').nullable()
})